import { useCallback, useEffect, useRef, useState } from "react";
import { useConversationsApi } from "../api/conversationsApi";

// A espera cresce sozinha com o relógio, então a tela precisa se atualizar sem
// alguém apertar nada — senão o número na tela envelhece e engana.
export function useWaitingResponse({ pollMs = 60000 } = {}) {
  const api = useConversationsApi();
  const [waiting, setWaiting] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const mounted = useRef(true);

  const fetchWaiting = useCallback(async () => {
    try {
      const data = await api.getWaiting();
      if (!mounted.current) return;
      setWaiting(data);
      setError(null);
    } catch (err) {
      if (mounted.current) setError(err.message);
    } finally {
      if (mounted.current) setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    mounted.current = true;
    fetchWaiting();

    if (!pollMs) return undefined;

    const timer = setInterval(fetchWaiting, pollMs);
    return () => {
      mounted.current = false;
      clearInterval(timer);
    };
  }, [fetchWaiting, pollMs]);

  return { waiting, loading, error, refetch: fetchWaiting };
}
